var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShoppingImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 140,
    viewBox: "0 0 128 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 75.7251,
    y: 49.3955,
    width: 52.153,
    height: 16.873,
    rx: 5,
    fill: "#E5F4F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.6898 107.813C92.9361 107.813 95.5677 105.181 95.5677 101.935C95.5677 98.6886 92.9361 96.057 89.6898 96.057C86.4436 96.057 83.812 98.6886 83.812 101.935C83.812 105.181 86.4436 107.813 89.6898 107.813Z",
    stroke: "#F49600",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67627 2H24.8996L40.8241 76.2613",
    stroke: "#585858",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8479 28.7537H110.244C112.408 28.7537 114.163 30.5081 114.163 32.6722C114.163 33.0498 114.108 33.4253 114.001 33.7873L103.47 69.2649C103.004 70.8355 101.61 71.9502 99.9752 72.0597L45.388 75.7143C40.7985 76.0216 37.2329 79.8339 37.2329 84.4336C37.2329 88.9476 40.8922 92.6069 45.4062 92.6069H100.724",
    stroke: "#585858",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8496 42.376H104.517",
    stroke: "#62C6E9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9258 58.0507H86.8967",
    stroke: "#62C6E9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.55664 29.6719H13.712",
    stroke: "#F49600",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2891 101.478C45.2891 98.5287 47.6799 96.1379 50.6291 96.1379H50.9186C54.0278 96.1379 56.5482 98.6584 56.5482 101.768V102.131C56.5482 105.441 53.8651 108.124 50.5553 108.124H20.8315",
    stroke: "#F49600",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingImg);
export default __webpack_public_path__ + "static/media/shoppingIMG.472afc699b53ea664ec12c46ed6a72b0.svg";
export { ForwardRef as ReactComponent };